export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    closeForm({commit}) {
        commit('closeForm');
    },
    closeGrid({commit}) {
        commit('closeGrid');
    },
    openGrid({commit}) {
        commit('openGrid');
    },
    showGrid({commit}) {
        commit('showGrid');
    },
    showForm({commit}) {
        commit('showForm');
    },
    showEhrForm({commit}) {
        commit('showEhrForm');
    },
    closeEhrForm({commit}) {
        commit('closeEhrForm');
    }
}
